import type { VueNode } from 'ant-design-vue/es/_util/type';

export const useXModal = () => {
  return useState<(() => VueNode)[]>('x-modal', () => []);
};
